export { MemoizedWeekdayDetailsSlots as WeekdayDetailsSlots } from './WeekdayDetailsSlots';
